import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './TrunctatedText.scss';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip'
import uuid from 'node-uuid';

export default class TrunctatedText extends Component {
    static propTypes = {
        className: PropTypes.string,
        text: PropTypes.string
    };

    state = {
        overflow: false
    };

    toolTipId = uuid.v4();

    componentDidMount() {
        this.checkOverflow();
    }

    componentWillReceiveProps() {
        this.setState({overflow: false});
    }

    componentDidUpdate() {
        this.checkOverflow();
    }

    checkOverflow() {
        const element = this.refs.text;

        const overflow = this.isTextOverflow(element);
        if (overflow !== this.state.overflow) {
            this.setState({overflow});
        }
    }

    isTextOverflow(element) {
        return element.clientWidth < element.scrollWidth;
    }

    render() {
        const {className, text} = this.props;
        const {overflow} = this.state;

        const textClassName = classNames(styles.text, className);

        return (
            <div ref='text'
                 className={textClassName}
                 data-tip={text}
                 data-for={this.toolTipId}>
                {text}
                {overflow && <ReactTooltip id={this.toolTipId}
                                           type='info'
                                           delayShow={500}
                                           effect='solid'/>}
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/controls/TrunctatedText.jsx